import { render, staticRenderFns } from "./LobbyFaq.vue?vue&type=template&id=0633226c&"
import script from "./LobbyFaq.vue?vue&type=script&lang=js&"
export * from "./LobbyFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports